import { render, staticRenderFns } from "./projects-final-report.vue?vue&type=template&id=de62ac10&scoped=true&"
import script from "./projects-final-report.vue?vue&type=script&lang=js&"
export * from "./projects-final-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de62ac10",
  null
  
)

export default component.exports